import React, { ReactNode } from 'react';
import { FullColor } from '../../layout/FullColor/FullColor';
import { PanelLayout } from '../../layout/Panel/Panel';
import { Spacing } from '../../layout/Spacing/Spacing';
import { CloseExec } from '../../ui/CloseButton';

interface IModalProps {
    isOpen: boolean;
    onTop?: boolean;
    onClose: () => void;
    children?: ReactNode;
    hasCloseIcon?: boolean;
    fullWidth?: boolean;
    useMarginAndPadding?: boolean;
    useAnimation?: boolean;
    execButtonDistance?: number
}

export const ParentModal: React.FC<IModalProps> = ({ execButtonDistance = 5, onTop = false, isOpen, onClose, children, hasCloseIcon = true, fullWidth = false, useMarginAndPadding = false, useAnimation = true }) => {
    if (!isOpen) return null;

    return (
        <FullColor onTop={onTop}>
            <div style={{ width: fullWidth ? '100%' : 'auto', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                <div className={`${useAnimation ? 'animation' : ''}`}>
                    <Spacing marginSpacing={`${useMarginAndPadding ? 'l' : 'none'}`} paddingSpacing={`${useMarginAndPadding ? 'l' : 'none'}`}>
                        <PanelLayout>
                            {hasCloseIcon && <CloseExec distanceInPx={execButtonDistance} func={onClose} />}
                            <Spacing marginSpacing={'none'} paddingSpacing={'l'}>
                                {children}
                            </Spacing>
                        </PanelLayout>
                    </Spacing>
                </div>
            </div>
        </FullColor>
    );
};
